import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_SEND_CHAT_MESSAGE = gql`
    mutation OnboardingSendChatMessage($request: SendMessageRequestDto!) {
        onboardingSendChatMessage(request: $request) {
            uuid
            candidateUuid
            senderName
            adminSender
            content
            modified
            editable
            createdAt
            adminReadAt
            candidateReadAt
        }
    }
`;

const useOnboardingSendChatMessage = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_SEND_CHAT_MESSAGE);

    const sendChatMessage = async (candidateUuid, content) => {
        return mutate({
            variables: {
                request: {
                    candidateUuid,
                    content,
                },
            },
        });
    };

    return {
        sendChatMessage,
        loading,
        error,
    };
};

export default useOnboardingSendChatMessage;
